<template>
  <div>
    <b-row>
      <b-col>
        <video id="localVideo" autoplay muted></video>
        <p> Local Candidate Id: {{ localCandidateId }}</p>
      </b-col>
      <b-col>
        <video id="remoteVideo" autoplay></video>
        <p> Remote Candidate Id: {{ remoteCandidateId }}</p>
      </b-col>
    </b-row>
    <b-button
        id="startButton"
        variant="primary"
        style="margin-left: 5px;"
        @click="start"
        :disabled="startButtonDisabled">
      Start
    </b-button>
    <b-button
        id="callButton"
        variant="primary"
        style="margin-left: 5px;"
        @click="call"
        :disabled="callButtonDisabled">
      Call
    </b-button>
    <b-button
        id="restartButton"
        variant="primary"
        style="margin-left: 5px;"
        @click="restart"
        :disabled="restartButtonDisabled">
      Restart
    </b-button>
    <b-button
        id="hangupButton"
        variant="primary"
        style="margin-left: 5px;"
        @click="hangup"
        :disabled="hangupButtonDisabled">
      Hang Up
    </b-button>
  </div>
</template>

<script>
export default {
  computed:{
    startButtonDisabled(){
      return !!this.localStream;
    },
    callButtonDisabled(){
      return !!(!this.localStream || this.pc2);
    },
    restartButtonDisabled(){
      return !!(!this.pc1);
    },
    hangupButtonDisabled(){
      return  !!(!this.localStream);
    }
  },
  methods: {
    start() {
      console.log('Requesting local stream');
      //this.startButtonDisabled = true;
      navigator.mediaDevices
          .getUserMedia({
            audio: true,
            video: true
          })
          .then(this.gotStream)
          .catch(e => alert(`getUserMedia() error: ${e.name}`));
    },
    gotStream(stream) {
      console.log('Received local stream');
      this.localStream = stream;
      const localVideo = document.getElementById('localVideo');
      localVideo.srcObject = stream;
      //this.callButtonDisabled = false;

      /*this.localVideo.addEventListener('loadedmetadata', function() {
        console.log(`Local video videoWidth: ${this.videoWidth}px,  videoHeight: ${this.videoHeight}px`);
      });*/
    },
    restart() {
      //this.restartButtonDisabled = true;
      this.offerOptions.iceRestart = true;
      console.log('pc1 createOffer restart');
      this.pc1.createOffer(this.offerOptions).then(this.onCreateOfferSuccess, this.onCreateSessionDescriptionError);
    },
    call() {
      //this.callButtonDisabled = true;
      //this.hangupButtonDisabled = false;
      console.log('Starting call');
      this.startTime = window.performance.now();
      const videoTracks = this.localStream.getVideoTracks();
      const audioTracks = this.localStream.getAudioTracks();
      if (videoTracks.length > 0) {
        console.log(`Using video device: ${videoTracks[0].label}`);
      }
      if (audioTracks.length > 0) {
        console.log(`Using audio device: ${audioTracks[0].label}`);
      }
      const servers = null;
      this.pc1 = window.pc1 = new RTCPeerConnection(servers);
      console.log('Created local peer connection object pc1');
      this.pc1.onicecandidate = e => this.onIceCandidate(this.pc1, e);
      this.pc2 = window.pc2 = new RTCPeerConnection(servers);
      console.log('Created remote peer connection object pc2');
      this.pc2.onicecandidate = e => this.onIceCandidate(this.pc2, e);
      this.pc1.oniceconnectionstatechange = e => {
        this.onIceStateChange(this.pc1, e);
        /*if (this.pc1 && this.pc1.iceConnectionState === 'connected') {
          //this.restartButtonDisabled = false;
        }*/
      };
      this.pc2.oniceconnectionstatechange = e => this.onIceStateChange(this.pc2, e);
      this.pc2.ontrack = this.gotRemoteStream;

      this.localStream.getTracks().forEach(track => this.pc1.addTrack(track, this.localStream));
      console.log('Added local stream to pc1');

      console.log('pc1 createOffer start');
      this.pc1.createOffer(this.offerOptions).then(this.onCreateOfferSuccess, this.onCreateSessionDescriptionError);
    },
    onCreateSessionDescriptionError(error) {
      console.log(`Failed to create session description: ${error.toString()}`);
    },
    onCreateOfferSuccess(desc) {
      console.log(`Offer from pc1\n${desc.sdp}`);
      console.log('pc1 setLocalDescription start');
      this.pc1.setLocalDescription(desc).then(() => this.onSetLocalSuccess(this.pc1), this.onSetSessionDescriptionError);
      console.log('pc2 setRemoteDescription start');
      this.pc2.setRemoteDescription(desc).then(() => this.onSetRemoteSuccess(this.pc2), this.onSetSessionDescriptionError);
      console.log('pc2 createAnswer start');
      this.pc2.createAnswer().then(this.onCreateAnswerSuccess, this.onCreateSessionDescriptionError);
    },
    onSetLocalSuccess(pc) {
      console.log(`${this.getName(pc)} setLocalDescription complete`);
    },
    onSetRemoteSuccess(pc) {
      console.log(`${this.getName(pc)} setRemoteDescription complete`);
    },
    onSetSessionDescriptionError(error) {
      console.log(`Failed to set session description: ${error.toString()}`);
    },
    gotRemoteStream(e) {
      const remoteVideo = document.getElementById('remoteVideo');
      if (remoteVideo.srcObject !== e.streams[0]) {
        remoteVideo.srcObject = e.streams[0];
        console.log('pc2 received remote stream');
      }
    },
    onCreateAnswerSuccess(desc) {
      console.log(`Answer from pc2:\n${desc.sdp}`);
      console.log('pc2 setLocalDescription start');
      this.pc2.setLocalDescription(desc).then(() => this.onSetLocalSuccess(this.pc2), this.onSetSessionDescriptionError);
      console.log('pc1 setRemoteDescription start');
      this.pc1.setRemoteDescription(desc).then(() => this.onSetRemoteSuccess(this.pc1), this.onSetSessionDescriptionError);
    },
    onIceCandidate(pc, event) {
      this.getOtherPc(pc)
          .addIceCandidate(event.candidate)
          .then(() => this.onAddIceCandidateSuccess(pc), err => this.onAddIceCandidateError(pc, err));
      console.log(`${this.getName(pc)} ICE candidate:\n${event.candidate ? event.candidate.candidate : '(null)'}`);
      this.checkStats(pc);
    },
    onAddIceCandidateSuccess(pc) {
      console.log(`${this.getName(pc)} addIceCandidate success`);
    },
    onAddIceCandidateError(pc, error) {
      console.log(`${this.getName(pc)} failed to add ICE Candidate: ${error.toString()}`);
    },
    onIceStateChange(pc, event) {
      if (pc) {
        console.log(`${this.getName(pc)} ICE state: ${pc.iceConnectionState}`);
        console.log('ICE state change event: ', event);
        this.checkStats(pc);
      }
    },
    getName(pc) {
      return (pc === this.pc1) ? 'pc1' : 'pc2';
    },
    getOtherPc(pc) {
      return (pc === this.pc1) ? this.pc2 : this.pc1;
    },
    checkStats(pc){
      console.log("checkStats");
      pc.getStats(null).then(results => {
        // figure out the peer's ip
        let activeCandidatePair = null;
        let remoteCandidate = null;

        // Search for the candidate pair, spec-way first.
        results.forEach(report => {
          if (report.type === 'transport') {
            activeCandidatePair = results.get(report.selectedCandidatePairId);
          }
        });
        // Fallback for Firefox.
        if (!activeCandidatePair) {
          results.forEach(report => {
            if (report.type === 'candidate-pair' && report.state === 'succeeded' && report.selected) {
              activeCandidatePair = report;
            }
          });
        }
        if (activeCandidatePair && activeCandidatePair.remoteCandidateId) {
          results.forEach(report => {
            if (report.type === 'remote-candidate' && report.id === activeCandidatePair.remoteCandidateId) {
              remoteCandidate = report;
            }
          });
        }
        console.log(remoteCandidate);
        if (remoteCandidate && remoteCandidate.id) {
          // TODO: update a div showing the remote ip/port?
          if ( pc== this.pc1 ) {
            this.localCandidateId = remoteCandidate.id;
          }else{
            this.remoteCandidateId = remoteCandidate.id;
          }
          //document.getElementById(pc === this.pc1 ? 'localCandidateId' : 'remoteCandidateId').textContent = remoteCandidate.id;
        }
      });
    },
    hangup() {
      console.log('Ending call');
      this.pc1.close();
      this.pc2.close();
      this.pc1 = null;
      this.pc2 = null;
      //this.hangupButton.disabled = true;
      //this.restartButton.disabled = true;
      //this.callButton.disabled = false;
    }
  },
  data() {
    return {
      localCandidateId:null,
      remoteCandidateId:null,
      localStream: null,
      pc1: null,
      pc2: null,
      startTime: null,
      offerOptions: {
        offerToReceiveAudio: 1,
        offerToReceiveVideo: 1
      }
    };
  },
};
</script>
